import { StatusAprovacao } from '@acme/core'
import { Box, Chip, SxProps, Theme } from '@mui/material'

interface IProps {
    status?: string
    sx?: SxProps<Theme>
}

export function CustomChip({ status, sx }: IProps) {
    return (
        <Box>
            {status === StatusAprovacao.PENDENTE && (
                <Chip sx={sx} label="PENDENTE" color="warning" />
            )}
            {status === StatusAprovacao.APROVADO && (
                <Chip sx={sx} label="APROVADO" color="success" />
            )}
            {status === StatusAprovacao.REPROVADO && (
                <Chip sx={sx} label="REPROVADO" color="error" />
            )}
            {status === StatusAprovacao.PENDENTE_EXCLUSAO && (
                <Chip sx={sx} label="EXCLUSÃO PENDENTE" color="warning" />
            )}
            {status === 'Aceito' && (
                <Chip sx={sx} label="ACEITO" color="success" />
            )}
            {status === 'Recusado' && (
                <Chip sx={sx} label="RECUSADO" color="error" />
            )}
        </Box>
    )
}
